<script>
    // routing
    import { Router, Link, Route } from "svelte-routing";
    import Home from "./routes/Home.svelte";
    import Projects from "./routes/Projects.svelte";
    import Researchers from "./routes/Researchers.svelte";

    import Researcher from "./routes/Researcher.svelte";
    import Project from "./routes/Project.svelte";
    import Tour from "./routes/Tour.svelte";
    import Lab from "./routes/Lab.svelte";
    import Experiments from "./routes/Experiments.svelte";
    import Modeling from "./routes/Modeling.svelte";
    import DataIntegration from "./routes/DataIntegration.svelte";
    import Clinics from "./routes/Clinics.svelte";

    export let url = "";
    //export let basepath = "/";

    // materialize
    import '../node_modules/materialize-css/dist/js/materialize'
    // init material plugins
    M.AutoInit()

    import Fa from 'svelte-fa'
    import {faExternalLinkAlt, faHome, faUsers, faCogs, faPlayCircle} from '@fortawesome/free-solid-svg-icons'
</script>

<Router url="{url}">
    <div class="navbar-fixed">
    <nav>
        <div class="nav-wrapper class">

            <ul id="nav-mobile" class="left">
                <li>
                    <Link to="/"><span class="nav-orange"><Fa icon={faHome}/> Home</span></Link>
                </li>
                <li>
                    <Link to="tour"><span class="nav-orange"><Fa icon={faPlayCircle}/> Virtual Tour</span></Link>
                </li>
                <li>
                    <Link to="projects"><span class="nav-orange"><Fa icon={faCogs}/> Projects</span></Link>
                </li>
                <li>
                    <Link to="researchers"><span class="nav-orange"><Fa icon={faUsers}/> Researchers</span></Link>
                </li>

                <!--
                <Li>
                    <Link to="lab">Virtual Lab</Link>
                </li>
                -->
            </ul>
            <Link to="/">
                <span class="right brand-logo color-orange"><span class="logo-orange">&nbsp;QuaLiPerF&nbsp;</span></span>
            </Link>
        </div>
    </nav>
    </div>
    <div>
        <Route path="projects" component="{Projects}" />
        <Route path="tour" component="{Tour}" />
        <Route path="projects/:id" component="{Project}"/>
        <Route path="researchers" component="{Researchers}" />
        <Route path="researchers/:id" component="{Researcher}"/>
        <Route path="tour" component="{Tour}" />
        <Route path="lab" component="{Lab}" />
        <Route path="/"><Home /></Route>
        <Route path="experiments"><Experiments /></Route>
        <Route path="modeling"><Modeling /></Route>
        <Route path="dataintegration"><DataIntegration /></Route>
        <Route path="clinics"><Clinics /></Route>

    </div>
</Router>

<style>
    nav {
        background-color: white;
    }
    .nav-orange{
        color: #004f9e;
        background-color: white;
        text-decoration: none;
    }
    .logo-orange{
        color: white;
        background-color: #004f9e;
        text-decoration: none;
    }

</style>